const SkipToContent = () => {
  return (
    <a
      href="#main-content"
      className="skip-to-content fixed top-0 left-0 z-[100] bg-primary text-primary-foreground px-4 py-2 -translate-y-full focus:translate-y-0 transition-transform"
    >
      Skip to main content
    </a>
  );
};

export default SkipToContent;
